import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { CssFlex } from "styles/helpers/layout";

export const StyledBetaChip = styled(CssFlex)<ThemeProps>`
  padding: 0.5rem 0.8rem;
  background-color: ${(props) => props.theme.palette.yellow._900};
  border-radius: 20px;
  gap: 0.5rem;
  align-items: center;
  font-size: 14px;
  justify-content: center;
  height: 1.8rem;
`;
